import { OrganizationState, ActivityState, ToastActions } from '@app/_store';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Action, State, StateContext, Store } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { SupportActions } from './support.actions';
import { SupportStateModel } from './support.models';
import { Observable } from 'rxjs';
import { SupportService } from '@app/_services';

@State<SupportStateModel>({
  name: 'support',
  defaults: {},
})
@Injectable()
export class SupportState {
  constructor(
    private store: Store,
    private http: HttpClient,

    private supportService: SupportService
  ) {}

  @Action(SupportActions.SendSupportEmail)
  sendSupportEmail(ctx: StateContext<SupportStateModel>, action: SupportActions.SendSupportEmail): Observable<void> {
    const currentOrganization = this.store.selectSnapshot(OrganizationState.current);
    const currentActivity = this.store.selectSnapshot(ActivityState.currentActivity);

    const errorText = 'Ett fel uppstod när frågan skulle skickas och vi undersöker problemet omgående!';

    return this.supportService
      .sendSupportEmail({
        organizationId: currentOrganization?.id ?? 'N/A',
        organizationName: currentOrganization?.name ?? 'N/A',
        activityId: currentActivity?.id ?? 'N/A',
        activityName: currentActivity?.name ?? 'N/A',
        body: action.body,
      })
      .pipe(
        map(response => {
          if (response.sent) {
            ctx.dispatch(new ToastActions.ShowSuccess('Din fråga har skickats och vi återkommer till dig inom kort!'));
          } else {
            ctx.dispatch(new ToastActions.ShowError(errorText));
          }
        }),
        catchError((err: HttpErrorResponse) => {
          ctx.dispatch(new ToastActions.ShowError(errorText));
          throw err;
        })
      );
  }
}
